import appConfig from '../config/appConfig';

const getP4DefaultImageByMarket = (iqosP4ImgSet: string, veevP4ImgSet: string): string => {
    const DEFAULT_IMAGE_VEEV = 'veev';
    const browserCheckPageLogoType = appConfig.getDefaultVeevImage()?.toLowerCase();
    const isVeevTitleVeevImage = browserCheckPageLogoType === DEFAULT_IMAGE_VEEV;

    return isVeevTitleVeevImage ? veevP4ImgSet : iqosP4ImgSet;
};

export default {
    getP4DefaultImageByMarket,
};
